import { render, staticRenderFns } from "./CertificateConfigPage.vue?vue&type=template&id=530a0fec&scoped=true&"
import script from "./CertificateConfigPage.vue?vue&type=script&lang=js&"
export * from "./CertificateConfigPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530a0fec",
  null
  
)

export default component.exports